import { createContext, useContext, useEffect, useState } from "react";
import { GTAG_CODE } from "../../constants";
import { Button } from "../button";

const CONSENT_STORAGE_KEY = "mycard_cookie_consent";
const CookieConsentContext = createContext(null);

export const CookieConsentProvider = ({ children }) => {
  const [analyticsConsent, setAnalyticsConsent] = useState(() =>
    window.localStorage.getItem(CONSENT_STORAGE_KEY)
  );

  useEffect(() => {
    if (analyticsConsent !== "granted") {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag || function gtag() {
        window.dataLayer.push(arguments);
      };
    window.gtag("js", new Date());

    if (!document.querySelector(`script[data-google-analytics="${GTAG_CODE}"]`)) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_CODE}`;
      script.dataset.googleAnalytics = GTAG_CODE;
      document.head.appendChild(script);
    }
  }, [analyticsConsent]);

  const updateConsent = (value) => {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, value);
    setAnalyticsConsent(value);
  };

  return (
    <CookieConsentContext.Provider value={{ analyticsConsent, updateConsent }}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsent = () => useContext(CookieConsentContext);

export const CookieConsentBanner = () => {
  const { analyticsConsent, updateConsent } = useCookieConsent();

  if (analyticsConsent) {
    return null;
  }

  return (
    <aside
      className="fixed bottom-4 right-4 z-[1000] flex w-[calc(100%-32px)] max-w-[680px] items-center gap-6 rounded-lg border border-grey-300 bg-white p-5 text-main-black shadow-[0_12px_36px_rgba(23,33,43,0.18)] max-[640px]:block"
      aria-label="Cookie consent"
    >
      <div className="min-w-0">
        <h2 className="m-0 text-base">Help us improve your experience</h2>
        <p className="m-0 mt-1 text-sm leading-[1.45] text-grey-600">
          We use analytics cookies to understand how visitors use MyCardGlobal.
          You can accept or decline them.
        </p>
      </div>
      <div className="flex shrink-0 gap-2 max-[640px]:mt-4">
        <Button
          type="button"
          text="Decline"
          variation="bland"
          onClick={() => updateConsent("denied")}
          className="w-auto border-grey-300 px-3 py-2 text-sm font-normal text-grey-700"
        />
        <Button
          type="button"
          text="Accept analytics"
          variation="primary"
          onClick={() => updateConsent("granted")}
          className="w-auto px-3 py-2 text-sm"
        />
      </div>
    </aside>
  );
};
